export enum QuestionnairePageType {
  affected = 'affected',
  familyBuilder = 'family_builder',
  cousin = 'cousin',
  halfSibling = 'half_sibling',
  nieceNephew = 'niece',
  familyMembers = 'family_table',
  twin = 'twin',
  finalNotes = 'final_notes',
  normal = 'normal',
}